import React from "react";
import { Navigate } from "react-router-dom";

const isValidFormat = (token) => {
  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) return false;
    
    // Convert URL-safe characters to standard Base64
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    
    // Add missing "=" padding so atob() doesn't crash
    const paddedBase64 = base64.padEnd(base64.length + (4 - (base64.length % 4)) % 4, "=");

    // Verify it can be parsed. We leave strict expiration checking to the PHP backend.
    JSON.parse(atob(paddedBase64));
    
    return true; 
  } catch (error) {
    console.error("Token decoding failed:", error);
    return false; // Treat as invalid if decoding fails
  }
};

const ProtectedRoute = ({ children }) => {
  // Check both token names used in your app
  const token = localStorage.getItem("token") || localStorage.getItem("auth_token");
  
  // If no token exists or the format is broken, clear storage and redirect to login
  if (!token || !isValidFormat(token)) {
    localStorage.removeItem("token");
    localStorage.removeItem("auth_token");
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

export default ProtectedRoute;
